<template>
    <div style="width:100%; height: 100%;display: flex;flex-direction: column;align-items: flex-start;justify-content: flex-start;">
        <div class="mapTitle">请选择要进入的工程</div>
        <div class="state">
            <div class="title">项目状态</div>
            <div class="stateLine">
                <div class="stateBox">
                    <div class="point1"></div>
                    <div class="text">进行中</div>
                </div>
                <div class="stateBox">
                    <div class="point2"></div>
                    <div class="text">未开始</div>
                </div>
                <div class="stateBox">
                    <div class="point3"></div>
                    <div class="text">已结束</div>
                </div>
            </div>
        </div>            
        <div ref="chinaMap" style="width: 100%; height: 1000px; margin: 0 auto"></div>
    </div>
</template>

<script>

// 引入基本模板
import * as echarts from 'echarts'
import dataJson from "../assets/data";
import { getProjectList, setProjectList } from '@/api/login'


export default {
    name: 'MapChart',
    data() {
        return {
            option: {
                geo: {
                    nameMap:{
                        'China': '中国'
                    },
                    map: 'china',
                    type:'map',
                    center: [108, 35],
                    zoom: 1.4,          // 地图放大
                    aspectScale: 0.8, //地图宽高比例
                    roam:true,        //地图缩放、平移
                    scaleLimit: {   //滚轮缩放的极限控制
                        min: 0.5, //缩放最小大小
                        max: 6, //缩放最大大小
                    },
                    itemStyle: {
                        areaColor: 'rgba(77, 146, 211, 0.8)',
                        borderColor: 'rgba(139, 196, 243, 1)',
                    },
                    // regions: [
                    //     {
                    //         name: '新疆维吾尔自治区',
                    //         itemStyle: {
                    //             shadowBlur: 10, // 阴影大小
                    //             shadowColor: 'rgba(154, 174, 217, 1)', // 阴影颜色
                    //             shadowOffsetX: -10, // 阴影水平方向上的偏移
                    //             shadowOffsetY: -10
                    //         }
                    //     },
                    //     {
                    //         name: '西藏自治区',
                    //         itemStyle: {
                    //             shadowBlur: 10, // 阴影大小
                    //             shadowColor: 'rgba(154, 174, 217, 1)', // 阴影颜色
                    //             shadowOffsetX: -10, // 阴影水平方向上的偏移
                    //             shadowOffsetY: 10
                    //         }
                    //     },
                    //     {
                    //         name: '云南省',
                    //         itemStyle: {
                    //             shadowBlur: 10, // 阴影大小
                    //             shadowColor: 'rgba(154, 174, 217, 0.6)', // 阴影颜色
                    //             shadowOffsetX: -10, // 阴影水平方向上的偏移
                    //             shadowOffsetY: 10
                    //         }
                    //     },
                    //     {
                    //         name: '广西壮族自治区',
                    //         itemStyle: {
                    //             shadowBlur: 10, // 阴影大小
                    //             shadowColor: 'rgba(154, 174, 217, 0.6)', // 阴影颜色
                    //             shadowOffsetX: 0, // 阴影水平方向上的偏移
                    //             shadowOffsetY: 10
                    //         }
                    //     },
                    //     {
                    //         name: '广东省',
                    //         itemStyle: {
                    //             shadowBlur: 10, // 阴影大小
                    //             shadowColor: 'rgba(154, 174, 217, 1)', // 阴影颜色
                    //             shadowOffsetX: -10, // 阴影水平方向上的偏移
                    //             shadowOffsetY: 10
                    //         }
                    //     },
                    // ]
                },
                series: [{
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    data: [
                        {
                            name: '平江工程',
                            value: [95.505955, 31.907497]
                        }
                    ],
                    label: {
                        show: true,
                        formatter: '{b}',
                        position: 'top',
                        distance: 20,
                    },
                    // 标记点样式
                    symbolSize: 16,
                    itemStyle: {
                        color: '#F06C00',
                    }
                }]
            }
        }
    },
    mounted() {
        // 初始化地图
        this.projectList();
    },
    methods: {
        projectList(){
            getProjectList().then(res=>{
                if(res.code ==1){
                    var dataArr = []
                    for(let i=0;i<res.data.length; i++){
                        let org = res.data[i]
                        let coordinate = org.coordinate
                        let s = coordinate.split(",")
                        let data
                        if(org.state == 1){
                            data = {
                                name: res.data[i].orgname,
                                value: [parseFloat(s[1]), parseFloat(s[0])],
                                id: res.data[i].id,
                                itemStyle: {
                                    color: '#F06C00'
                                }
                            }
                        }else if(org.state == 2){
                            data = {
                                name: res.data[i].orgname,
                                value: [parseFloat(s[1]), parseFloat(s[0])],
                                id: res.data[i].id,
                                itemStyle: {
                                    color: '#7F7F7F'
                                }
                            }
                        }else if(org.state == 3){
                            data = {
                                name: res.data[i].orgname,
                                value: [parseFloat(s[1]), parseFloat(s[0])],
                                id: res.data[i].id,
                                itemStyle: {
                                    color: '#75BD42'
                                }
                            }
                        }
                        
                        dataArr.push(data)
                    }
                    this.option.series[0].data = dataArr
                    this.initMap()
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        initMap() {
            var that = this
            let myChart = echarts.init(this.$refs.chinaMap);
            let uploadDataUrl = dataJson;
            // 注册地图
            echarts.registerMap("china", uploadDataUrl);
            myChart.setOption(this.option);
            myChart.on('click', function (params) {
                if(that.$isNotNull(params.data)){
                    setProjectList(params.data.id).then(res=>{
                        if(res.code ==1){
                            if(res.data == '2'){
                                this.$router.push({path: '/workreport/list'})
                            }else{
                                this.$router.push({path: '/home'})
                            }
                        }else{
                            that.$msg(res.msg)
                        }
                    })
                }
            });
        },
        
    },
}
</script>
<style>
    .mapTitle{
        width:100%;
        text-align: center;
        font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        font-size: 34px;
        margin-top: 20px;
    }
    .state {
        width:280px;
        height: 100px;
        position: absolute;
        right: 30px;
        bottom: 30px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        background-color: #ebeef5;
        padding: 20px;
        box-sizing: border-box;
        border-radius: 10px;
    }
    .state .title {
        font-size: 16px;
        color: #303133;
        font-weight: bold;
        margin-bottom: 14px;
    }
    .stateLine {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
    .stateLine .stateBox {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
    }
    .stateLine .stateBox .point1{
        width: 20px;
        height: 20px;
        border-radius: 50%;
        box-shadow: 0 0 6px #F06C00;
        background-color: #F06C00;
    }
    .stateLine .stateBox .point2{
        width: 20px;
        height: 20px;
        border-radius: 50%;
        box-shadow: 0 0 6px #7F7F7F;
        background-color: #7F7F7F;
    }
    .stateLine .stateBox .point3{
        width: 20px;
        height: 20px;
        border-radius: 50%;
        box-shadow: 0 0 6px #75BD42;
        background-color: #75BD42;
    }
    .stateLine .stateBox .text{
        color: #303133;
        font-size: 14px;
        margin-left: 6px;
    }
</style>